var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWork3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 86,
    viewBox: "0 0 94 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41589 80.3419L8.84495 78.7446C15.7352 77.2008 22.903 77.4137 29.6895 79.3636C35.0803 80.901 41.6691 82.658 46.6406 83.6163C48.1065 83.8952 49.6147 83.8615 51.0666 83.5174C52.5185 83.1734 53.8814 82.5267 55.0663 81.6197C66.4934 73.5654 78.4613 66.3073 90.8853 59.8967C91.1326 59.7658 91.3451 59.5778 91.505 59.3482C91.665 59.1186 91.7678 58.8541 91.8049 58.5768C91.842 58.2995 91.8124 58.0173 91.7184 57.7537C91.6244 57.4902 91.4689 57.2528 91.2647 57.0615C86.1334 52.11 79.1852 53.9469 73.1954 57.4209C71.9377 58.1259 70.596 58.6693 69.2022 59.0382L64.1308 60.4158",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.83514 57.9C2.83514 57.9 8.98468 50.832 27.7927 50.832C29.929 50.832 37.1168 53.188 41.7689 54.965C44.3823 55.9654 47.1566 56.4797 49.9549 56.4824H57.6219C59.2105 56.4824 60.734 57.1135 61.8573 58.2368C62.9806 59.3601 63.6117 60.8836 63.6117 62.4722C63.6117 64.0608 62.9806 65.5843 61.8573 66.7076C60.734 67.831 59.2105 68.462 57.6219 68.462H37.6559",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4312 21.3222C80.0437 28.7096 70.5599 23.4386 70.5599 23.4386C70.5599 23.4386 65.2689 13.9348 72.5565 6.54736C78.8857 0.218137 91.5641 2.33453 91.5641 2.33453C91.5641 2.33453 93.8403 14.993 87.4312 21.3222Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9524 18.8862C29.0738 20.0831 29.7909 21.6021 30.0022 23.2286C30.2136 24.8551 29.9086 26.5069 29.1304 27.9507C27.6929 28.7295 26.0475 29.0385 24.4253 28.8344C22.8032 28.6303 21.2857 27.9233 20.0858 26.8127C16.6916 23.4384 17.8297 16.65 17.8297 16.65C17.8297 16.65 24.5982 15.4919 27.9524 18.8862Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5034 50.3327C23.696 44.6247 27.6997 39.7931 32.9011 36.5783C38.1025 33.3636 44.2145 31.943 50.3004 32.5344C56.3864 33.1258 62.1106 35.6964 66.5957 39.8524C71.0809 44.0084 74.0795 49.5205 75.1321 55.5438",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5922 46.3997L79.5446 14.4541",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.209 29.9477L59.5786 22.4404",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6194 34.42L29.6296 28.4302",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork3);
export default __webpack_public_path__ + "static/media/work3.77137fc855cf88a049987a37357e40a2.svg";
export { ForwardRef as ReactComponent };